import { FormTextField } from "components/Forms/FormTextField";
import { Control } from "react-hook-form";

interface MergedWasteStreamCommentInputProps {
  control: Control<any>;
}

export const MergedWasteStreamCommentInput = ({ control }: MergedWasteStreamCommentInputProps) => {
  return (
    <FormTextField
      name="comment"
      label="Comment"
      control={control}
      textFieldProps={{
        multiline: true,
      }}
      inputProps={{
        placeholder: "Add Comment",
      }}
      InputLabelProps={{
        shrink: true,
      }}
      hideErrors={true}
      fullWidth
    />
  );
};
